import clone from "lodash/clone"

const initialState = {
  byModuleName: {},
  triggerServices: [],
  queryServices: [],
  actionServices: [],
}

export default function services(state = initialState, event) {
  switch (event.type) {
    default: {
      return state
    }

    case "SERVICES_LOADED": {
      // This is a shallow clone, so we don't copy the service objects
      const byModuleName = clone(state.byModuleName)
      const triggerServices = []
      const queryServices = []
      const actionServices = []

      event.services.forEach(service => {
        byModuleName[service.module_name] = service
      })

      Object.values(byModuleName).forEach(service => {
        if (service.trigger_count) {
          triggerServices.push(service)
        }

        if (service.query_count) {
          queryServices.push(service)
        }

        if (service.action_count) {
          actionServices.push(service)
        }
      })

      return {
        byModuleName,
        triggerServices,
        queryServices,
        actionServices,
      }
    }
  }
}

export const serviceQueryFields = `
  id
  module_name
  name
  description
  lrg_variant_image_url
  lrg_monochrome_image_url
  brand_color
  trigger_count
  query_count
  action_count
  normalized_module_name
  connect_enabled
  incompatible_channels
  public_actions {
    name
    incompatible_triggers
  }
  public_queries { name }
  public_triggers { name }
`
